/**
 * Returns the brand from the dataLayer.
 */

export default () => {
    const data = window?.dataLayer?.[0] ?? {};
    return data.brand ?? "";
}